export const normalizeCaptions = captions =>
    captions?.map?.(({label, captionUrl, languageCode} = {}) => ({
        label,
        captionUrl,
        langCode: languageCode
    })) ?? [];
